import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { LockIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
export function PriceBlock() {
  return <section id="price-block" className="py-24 bg-navy-900 px-4 relative overflow-hidden" data-id="element-145">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-electric-600/20 blur-[150px] rounded-full pointer-events-none" data-id="element-146"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(37,99,235,0.3)] border-4 border-electric-600" data-id="element-148">
          <h2 className="text-4xl md:text-5xl font-bold text-navy-900 mb-6" data-id="element-149">
            Es hora de dejar de planear y empezar a ejecutar.
          </h2>

          <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-150">
            Por el precio de una cena rápida, puedes obtener la hoja de ruta que
            te ahorrará meses de frustración y errores técnicos costosos.
          </p>

          <div className="bg-gray-50 rounded-2xl p-8 mb-10 border border-gray-200 inline-block w-full max-w-md" data-id="element-151">
            <div className="text-gray-500 font-bold uppercase tracking-widest mb-2" data-id="element-152">
              Acceso Inmediato
            </div>
            <div className="text-navy-900 text-2xl font-bold mb-2" data-id="element-153">
              Sistema Shopify Express 48H
            </div>
            <div className="flex justify-center items-baseline gap-2 mb-4" data-id="element-154">
              <span className="text-gray-400 line-through text-2xl" data-id="element-155">
                $97.00
              </span>
              <span className="text-6xl font-bold text-brandOrange-500" data-id="element-156">
                $6.39
              </span>
              <span className="text-gray-500 font-medium" data-id="element-157">USD</span>
            </div>
          </div>

          <div className="max-w-md mx-auto" data-id="element-158">
            <CTAButton className="w-full text-2xl py-6 mb-6" data-id="element-159" />

            <div className="flex flex-col items-center gap-4" data-id="element-160">
              <div className="flex items-center gap-2 text-green-600 font-medium bg-green-50 px-4 py-2 rounded-full" data-id="element-161">
                <LockIcon className="w-4 h-4" data-id="element-162" />
                <span data-id="element-163">
                  Compra segura. Recibe el acceso a tu PDF al instante.
                </span>
              </div>

              <div className="flex items-center justify-center gap-4 text-gray-400 mt-4" data-id="element-164">
                <ShieldCheckIcon className="w-8 h-8" data-id="element-165" />
                <CreditCardIcon className="w-8 h-8" data-id="element-166" />
                {/* Generic payment icons representation */}
                <div className="flex gap-1" data-id="element-167">
                  <div className="w-10 h-6 bg-gray-200 rounded" data-id="element-168"></div>
                  <div className="w-10 h-6 bg-gray-200 rounded" data-id="element-169"></div>
                  <div className="w-10 h-6 bg-gray-200 rounded" data-id="element-170"></div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}